import React, { useContext } from 'react';
import { StyleProp, ViewStyle } from 'react-native';
import { MBButton } from '@shared/components/button';
import { TimeTrackerComponentData } from '@shared/data/entity/fields/TimeTrackerField';
import { ColorThemeContext } from '@shared/styles';
import { useOnStartTimeTracker, useOnStopTimeTracker } from './hooks';

interface Props {
  component: MBAPI.WorkflowTemplate_components_TimeTrackerComponent;
  data: TimeTrackerComponentData;
  loading?: boolean;
  isRunning: boolean;
  size: 'small' | 'normal' | undefined;
  style?: StyleProp<ViewStyle>;
  onDataChanged: (newData: TimeTrackerComponentData) => void;
}

export function TimeTrackerButton({
  component,
  data,
  loading = false,
  isRunning,
  size,
  style,
  onDataChanged,
}: Props) {
  const colors = useContext(ColorThemeContext);
  const onPressStart = useOnStartTimeTracker(data, onDataChanged);
  const onPressStop = useOnStopTimeTracker(data, onDataChanged);
  const running = loading ? !isRunning : isRunning;

  return (
    <MBButton
      title={running ? component.endButtonLabel : component.startButtonLabel}
      theme="outline"
      borderColor={running ? colors.button.destructive : undefined}
      titleColor={running ? colors.button.destructive : undefined}
      size={size}
      style={style}
      onPress={running ? onPressStop : onPressStart}
    />
  );
}
